// @ts-check

import { cloneDeep } from "lodash";

/**
 * Don't expose, apollo objects are frozen so doing an in place delete isn't possible anyway.
 * @param {any} obj
 * @returns {any}
 */
const deleteTypenameRecursively = (obj) => {
  if (obj && typeof obj === "object") {
    if (Array.isArray(obj)) {
      obj.forEach(deleteTypenameRecursively);
    } else {
      delete obj.__typename;

      for (const key in obj) {
        deleteTypenameRecursively(obj[key]);
      }
    }
  }
  return obj;
};

/**
 * Omit the __typename from a given object.
 * Useful because Apollo includes the __typename in query payload but expects them to be absent in mutation payload.
 * @param {any} obj - The object to omit the __typename from.
 * @returns {any} - The object with the __typename omitted.
 */
export const omitTypename = (obj) => {
  return deleteTypenameRecursively(cloneDeep(obj));
};

// used to correlate issues in sentry
export const createTransactionId = () =>
  Math.random().toString(36).substr(2, 9);
